import React, { useMemo } from "react";
import { PersonalizationStatus } from "@foundation/personalization";

import ZoneModule from "~components/modules/zoneModule/zoneModule";
import type { ModuleRenderingProps } from "~components/shared/zones/utility";
import useRedux from "~redux/hooks";
import type { VariationComponent } from "~types/types";

interface PersonalizedModuleShadowProps {
    module: VariationComponent;
    preview: boolean;
    renderingData: ModuleRenderingProps;
    duplicateOf: string;
}

function PersonalizedModuleShadow({
    module,
    renderingData,
    preview,
    duplicateOf,
}: PersonalizedModuleShadowProps) {
    const { useAppSelector } = useRedux();
    const { personalizationStories } = useAppSelector(
        (state) => state.personalization
    );

    const storiesKey = duplicateOf;

    const moduleWithPersonalizedItems = useMemo(() => {
        return {
            ...module,
            items: personalizationStories[storiesKey].recommendations,
        };
    }, [module, personalizationStories]);

    if (
        personalizationStories[storiesKey].status !== PersonalizationStatus.Done
    ) {
        return <></>;
    }

    if (personalizationStories[storiesKey].error !== undefined) {
        return (
            <ZoneModule
                module={module}
                renderingData={renderingData}
                preview={preview}
            />
        );
    }

    return (
        <ZoneModule
            module={moduleWithPersonalizedItems}
            renderingData={renderingData}
            preview={preview}
        />
    );
}

export default PersonalizedModuleShadow;
